import {objectToQuery} from '@jetbrains/teamcity-ui/dist/utils'

import {BS} from '../types/BS_types'

export const resolveRelativeCustomBase = (base: string, relative: string, params?: {}): string =>
  /* $FlowFixMe This comment suppresses an error found when upgrading Flow to
   * v0.142.0. To view the error, delete this comment and run Flow. */
  base + relative + (params ? `?${objectToQuery(params)}` : '')
export const escapeFilePathForURL = (path: string): string =>
  path.split('/').map(encodeURIComponent).join('/')
export const parseURL = (url: string): HTMLAnchorElement => {
  const parser = document.createElement('a')
  parser.href = url
  return parser
}
const helpUrlPrefix = (BS?.helpUrlPrefix ?? '').replace(/\?$/, '')
export const resolveHelpURL = (page: string): string => `${helpUrlPrefix}${page}`
